import { render, staticRenderFns } from "./TermsRefund.vue?vue&type=template&id=25c5e9ed&scoped=true&"
var script = {}
import style0 from "./TermsRefund.vue?vue&type=style&index=0&id=25c5e9ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c5e9ed",
  null
  
)

export default component.exports